import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from 'seagull';
export const MondaySteps = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: "2. Click Integrate on your monday.com board"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: "3. Search Anchor and select an automation recipe"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: "4. When prompted, paste your API key into the Anchor API Key field"
            })
        ]
    });
